(function () {
  var userOpened = false;

  function quoteCount() {
    var quote = window.Quottee;
    if (!quote) return 0;
    var live = 0;
    if (typeof quote.furnitureCount === 'function' && typeof quote.getQuoteState === 'function') {
      live = quote.furnitureCount(quote.getQuoteState()) || 0;
    }
    if (live > 0) return live;
    if (typeof quote.furnitureCountFromStorage === 'function') return quote.furnitureCountFromStorage() || 0;
    return 0;
  }

  function openSheet(quote) {
    userOpened = true;
    var open = function () {
      if (!quote || typeof quote.setSheetState !== 'function') return;
      quote.setSheetState('half');
    };
    if (typeof quote.setSheetState === 'function') {
      open();
      return;
    }
    if (typeof quote.ensureCart === 'function') quote.ensureCart().then(open);
  }

  function keepCollapsed() {
    var quote = window.Quottee;
    if (!quote || typeof quote.setSheetState !== 'function') return;
    if (quoteCount() < 1 || userOpened) return;
    var state = quote.runtime && quote.runtime.sheetState;
    if (state === 'full') return;
    if (state === 'peek') return;
    quote.setSheetState('peek');
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!event.target.closest || !event.target.closest('[data-quottee-sheet-arrow]')) return;
      var state = window.Quottee && window.Quottee.runtime && window.Quottee.runtime.sheetState;
      if (state === 'peek' || state === 'gone' || !state) userOpened = true;
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest || !event.target.closest('[data-quottee-sheet-arrow]')) return;
      var quote = window.Quottee;
      if (!quote) return;
      event.preventDefault();
      var state = quote.runtime && quote.runtime.sheetState;
      if (state === 'half' || state === 'full') {
        userOpened = false;
        if (typeof quote.setSheetState === 'function') quote.setSheetState('peek');
        return;
      }
      openSheet(quote);
    },
    true
  );

  function watch() {
    var shell = document.querySelector('[data-quottee-mounted]');
    if (!shell || shell.getAttribute('data-desktop-half-watch') === '1') return;
    shell.setAttribute('data-desktop-half-watch', '1');
    new MutationObserver(keepCollapsed).observe(shell, {
      attributes: true,
      attributeFilter: ['data-quottee-sheet-state']
    });
    keepCollapsed();
  }

  var scrollDimTimer = null;
  function dimArrowOnScroll() {
    var arrow = document.querySelector('button.quottee-sheet__arrow');
    if (!arrow) return;
    var state = arrow.getAttribute('data-quottee-sheet-state');
    if (state === 'half' || state === 'full') return;
    arrow.setAttribute('data-quottee-sheet-scrolling', '');
    if (scrollDimTimer) window.clearTimeout(scrollDimTimer);
    scrollDimTimer = window.setTimeout(function () {
      scrollDimTimer = null;
      if (arrow.isConnected) arrow.removeAttribute('data-quottee-sheet-scrolling');
    }, 220);
  }
  window.addEventListener('scroll', dimArrowOnScroll, { passive: true });

  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    watch();
    keepCollapsed();
    if (tries > 40) window.clearInterval(timer);
  }, 250);
})();
